<template>
	<div>
		<!-- cabecalho -->
		<div class="fl-cabecalho no-print" v-show="cabecalho">
			<div class="row">
				<div class="col-lg-4 col-xs-6">
					<i class="icon icon-prevencao"></i>
					<h3>{{ _traducao('submenu', 'cadPrevencao').toUpperCase() }}</h3>
					<h4 @click="_exibeSub('so')" style="cursor: pointer;">
						{{ _traducao('menu', 'segurancaOperacional').toUpperCase() }}
						<i class="fa fa-angle-down" aria-hidden="true"></i>
					</h4>
				</div>

				<div class="col-lg-4 col-xs-6">
					<span v-if="form.id == 0">
						<i class="icon icon-solicitacao_nova_solicitacao icon-sub"></i>
						<h3>{{ _traducao('global', 'nova').toUpperCase() }}</h3>
					</span>

					<span v-if="form.id != 0">
						<i class="icon icon-editar icon-sub"></i>
						<h3>{{ _traducao('global', 'editar').toUpperCase() }}</h3>
					</span>

					<h4>
						{{ _traducao('menuAGprevencao', 'menuAGpPrevencao').toUpperCase() }}
					</h4>
				</div>

				<div class="col-lg-4 col-xs-12">
					<button @click="$emit('volta-lista')" class="btn btn-default pull-right btn-lg" :title="_traducao('global', 'voltar')">
						<i class="icon-left" style="font-size: 18px;" aria-hidden="true"></i>
					</button>
				</div>
			</div>
		</div>

		<!-- form -->
		<div v-show="exibeForm" style="margin-top: 20px;">
			<div class="row">
				<!--  DATA E HORA -->
				<div class="form-group col-md-6" :class="{'has-error': erro.data != ''}">
					<label> * {{ _traducao('menuAGprevencao', 'menuAGdataOcorrencia') }}: </label>
					<flDateTime
						@v-model="(val) => (form.data = val)"
						:value="form.data"
						time="HH:mm"
						name="prevencao"
						:lang="_getLangDp"
						:format="_formatDate"
					/>
					<p class="help-block" v-show="erro.data != ''">{{ erro.data }}</p>
				</div>
				<div class="form-group col-sm-6" :class="{'has-error': erro.local != ''}">
					<label>* {{ _traducao('menuAGpermutas', 'menuAGlocal') }}:</label>
					<input type="text" v-model="form.local" class="form-control input-sm" />
					<p class="help-block" v-show="erro.local != ''">{{ erro.local }}</p>
				</div>
			</div>
			<div class="row">
				<div class="form-group col-md-3" :class="{'has-error': erro.idEstado != ''}">
					<label>* {{ _traducao('global', 'estado') }}:</label>
					<select v-model="form.idEstado" @change="carregaCidades(form.idEstado)" class="form-control input-sm">
						<option value="">{{ _traducao('global', 'escolha').toUpperCase() }}</option>
						<option v-for="estado in estados" :value="estado.id" :key="estado.id">{{ estado.nome.toUpperCase() }}</option>
					</select>
					<p class="help-block" v-show="erro.idCidade != ''">
						{{ erro.idCidade }}
					</p>
				</div>

				<div class="form-group col-md-3" :class="{'has-error': erro.idCidade != ''}">
					<label>* {{ _traducao('menuAGnovoUsuario', 'menuAGcidade') }}:</label>
					<select v-show="!carregandoCidades" v-model="form.idCidade" class="form-control input-sm">
						<option value="">{{ _traducao('global', 'escolha').toUpperCase() }}</option>
						<option v-for="cidade in cidades" :value="cidade.id" :key="cidade.id">{{ cidade.descricao.toUpperCase() }}</option>
					</select>
					<flCarregando v-show="carregandoCidades" />
					<p class="help-block" v-show="erro.idCidade != ''">
						{{ erro.idCidade }}
					</p>
				</div>

				<div class="form-group col-md-3">
					<label>{{ _traducao('menuAGprevencao', 'menuAGaeronave') }}:</label>
					<select v-model="form.idAeronave" class="form-control input-sm">
						<option v-for="aeronave in aeronaves" :value="aeronave.id" :key="aeronave.id">{{ aeronave.descricao }}</option>
					</select>
				</div>

				<div class="form-group col-md-3">
					<label>{{ _traducao('global', 'evento') }}:</label>
					<select v-if="!carregandoEventos" v-model="form.idEvento" class="form-control input-sm">
						<option v-for="evento in eventos" :value="evento.id" :key="evento.id">{{ evento._label }}</option>
					</select>
					<flCarregando v-else />
				</div>
			</div>
			<div class="row">
				<div class="form-group col-md-12">
					<label> {{ _traducao('menuAGprevencao', 'menuAGenvolvidos') }}:</label>
					<textarea v-model="form.envolvidos" class="form-control input-sm"> </textarea>
				</div>
			</div>

			<div class="row">
				<div class="form-group col-md-12" :class="{'has-error': erro.descricao != ''}">
					<label>* {{ _traducao('menuAGprevencao', 'menuAGdescricao') }}:</label>
					<textarea v-model="form.descricao" class="form-control input-sm"> </textarea>
					<p class="help-block" v-show="erro.descricao != ''">
						{{ erro.descricao }}
					</p>
				</div>
			</div>

			<div class="row">
				<div class="form-group col-sm-4" :class="{'has-error': erro.relator != ''}">
					<label>{{ _traducao('menuAGprevencao', 'menuAGrelator') }}:</label>
					<input type="text" v-model="form.relator" class="form-control input-sm" />
					<p class="help-block" v-show="erro.relator != ''">
						{{ erro.relator }}
					</p>
				</div>
				<div class="form-group col-sm-4" :class="{'has-error': erro.telefone != ''}">
					<label>{{ _traducao('global', 'telefone') }}:</label>
					<input v-model="form.telefone" class="form-control input-sm" v-mask="_vtelefone" />
					<p class="help-block" v-show="erro.telefone != ''">
						{{ erro.relator }}
					</p>
				</div>
				<div class="form-group col-sm-4" :class="{'has-error': erro.email != ''}">
					<label>{{ _traducao('menuAGprevencao', 'menuAGemail') }}:</label>
					<input type="text" v-model="form.email" class="form-control input-sm" />
					<p class="help-block" v-show="erro.email != ''">{{ erro.email }}</p>
				</div>
			</div>
			<hr />
			<div class="row">
				<div class="col-md-10 text-info">
					<p>
						<i class="fa fa-info-circle"></i>
						{{ _traducao('global', 'obrigatorio') }}
					</p>
				</div>
				<div class="col-md-2">
					<button class="btn btn-success btn-block pull-right" type="button" @click="clickSalva()">
						<i class="fa fa-check fa-fw"></i>{{ _traducao('global', 'salvar').toUpperCase() }}
					</button>
				</div>
			</div>
		</div>

		<div v-show="!exibeForm">
			<div class="row">
				<div class="col-md-12 text-center text-success" style="height: 310px;">
					<h1 style="margin-top: 100px;">
						<i class="fa fa-check-circle fa-fw"></i>{{ _traducao('menuAGpermutas', 'menuAGsalvo') }}
					</h1>

					<button class="btn btn-default" type="button" @click="clickImprimir()">
						<i class="fa icon-imprimir r-print"></i>
						{{ _traducao('global', 'imprimir') }}
					</button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		cabecalho: {
			default: true,
			type: Boolean,
			required: false
		}
	},
	data() {
		return {
			id: 0,
			exibeForm: true,
			carregandoCidades: false,
			carregandoEventos: false,
			estados: [],
			aeronaves: [],
			eventos: [],
			cidades: [],
			form: {
				id: 0,
				local: '',
				data: '',
				idAeronave: '',
				idEstado: '',
				idEvento: '',
				idCidade: '',
				envolvidos: '',
				descricao: '',
				relator: '',
				email: '',
				telefone: ''
			},
			erro: {
				local: '',
				data: '',
				idEstado: '',
				idAeronave: '',
				idCidade: '',
				descricao: '',
				relator: '',
				email: '',
				telefone: ''
			}
		}
	},
	mounted() {
		this.carregaDados()
		this.setaEstado()
	},
	methods: {
		clickImprimir() {
			this.$emit('atualiza-lista', {id: this.form.id})
		},
		clickSalva() {
			if (this.validaForm()) {
				this.form.data = this._dateTimeToDateSQL(this.form.data, `${window.$sessao.getDateFormat()} HH:MM:SS`)
				window.bus.$emit('load-in', {
					text: this._traducao('global', 'salvando')
				})
				this._httpPost('/Relatorio_prevencao/salvar_prevencao', this.form, (retorno) => {
					if (retorno._request) {
						window.bus.$emit('load-out')
						this.$emit('atualiza-lista', retorno.relatorio_prevencao[0])
					}
				})
			}
		},
		validaForm() {
			let passou = true
			const obrigatorio = this._traducao('global', 'campoObrigatorio')
			if (this.form.data.trim() == '') {
				this.erro.data = obrigatorio
				passou = false
			} else {
				this.erro.data = ''
			}
			if (this.form.local.trim() == '') {
				this.erro.local = obrigatorio
				passou = false
			} else {
				this.erro.local = ''
			}
			if (this.form.idEstado == '') {
				this.erro.idEstado = obrigatorio
				passou = false
			} else {
				this.erro.idEstado = ''
			}
			if (this.form.idCidade == '') {
				this.erro.idCidade = obrigatorio
				passou = false
			} else {
				this.erro.idCidade = ''
			}
			if (this.form.descricao.trim() == '') {
				this.erro.descricao = obrigatorio
				passou = false
			} else {
				this.erro.descricao = ''
			}
			return passou
		},
		// CARREGA A A ESCALA
		carregaCidades(idEstado) {
			if (idEstado) {
				this.carregandoCidades = true
				this._httpGet(`/Cidade/get_cidade_by_id_estado/${idEstado}`, (retorno) => {
					if (retorno._request && retorno._status) {
						retorno.lista = retorno.lista.map((cidade) => {
							cidade.descricao = cidade.descricao.toUpperCase()
							return cidade
						})
						this.carregandoCidades = false
						this.cidades = retorno.lista
					} else if (!retorno._status) {
						this.carregandoCidades = false
					}
				})
			} else {
				this.cidades = []
			}
		},
		setaEstado() {
			this.form.idEstado = window.$cliente.get('id_estado')
			this.carregaCidades(window.$cliente.get('id_estado'))
		},
		// CARREGA TODOS OS SELECTS
		carregaDados() {
			// AERONAVE
			this._httpGet('/Aeronave/get_aeronave', (retorno) => {
				if (retorno._request && retorno._status) {
					const aeronaves = retorno.lista.map((aeronave) => ({
						id: aeronave.id,
						descricao: `${aeronave.codinome} - ${aeronave.prefixo}`
					}))
					aeronaves.unshift({
						id: null,
						descricao: this._traducao('global', 'escolha').toUpperCase()
					})
					this.aeronaves = aeronaves
				}
			})
			this._providerEstado((estados) => {
				this.estados = estados
				this.setaEstado()
			})
			this.carregandoEventos = true
			this._httpGet('evento/get_lista_evento', (retorno) => {
				this.eventos = retorno.lista.map((evento) => {
					evento._label = `${evento.tipo} - ${evento.descricao}`
					return evento
				})
				this.carregandoEventos = false
			})
		}
	}
}
</script>